
import React from 'react';
import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';
import { useIsMobile } from '@/hooks/use-mobile.jsx';

function CourseCard({ image, title, priceARS, priceUSD, link, delay = 0 }) {
  const isMobile = useIsMobile();
  const isExternal = /^https?:\/\//.test(link);
  const buttonClassName = "btn-base min-h-12 w-fit rounded-lg bg-white py-2.5 text-lg text-primary transition-colors duration-300 hover:bg-accent";
  const motionProps = isMobile
    ? { initial: false, animate: { opacity: 1, y: 0, scale: 1 } }
    : {
      initial: { opacity: 0, y: 36, scale: 0.98 },
      whileInView: { opacity: 1, y: 0, scale: 1 },
      viewport: { once: true },
      transition: { duration: 0.65, delay, ease: [0.22, 1, 0.36, 1] }
    };

  return (
    <motion.div
      {...motionProps}
      className="mx-auto flex h-full w-full max-w-[440px] flex-col overflow-hidden rounded-xl bg-primary shadow-sm transition-all duration-300 hover:-translate-y-1 hover:shadow-md sm:max-w-none"
    >
      {/* Top Section: Clean Image without excessive corners or borders */}
      <div className="relative aspect-[3/2] w-full overflow-hidden bg-primary/20">
        <img 
          src={image} 
          alt={title}
          loading="lazy"
          decoding="async"
          className="h-full w-full object-cover opacity-95 transition-transform duration-700 group-hover:scale-105 md:opacity-90 md:group-hover:opacity-100"
        />
      </div>
      
      {/* Bottom Section: Solid Orange Block */}
      <div className="p-6 text-center flex-1 flex flex-col items-center justify-between">
        <h3 className="font-rocky-extra-light mb-5 text-4xl italic leading-tight text-white text-balance">
          {title}
        </h3>
        
        <div className="space-y-3 mb-6 w-full">
          <div>
            <p className="font-sans font-normal text-[0.7rem] md:text-xs text-white/90 tracking-widest uppercase mb-1">
              MERCADO PAGO DESDE ARGENTINA
            </p>
            <p className="font-sans text-base md:text-lg font-bold text-white tracking-wide">
              {priceARS}
            </p>
          </div>
          
          <div>
            <p className="font-sans font-normal text-[0.7rem] md:text-xs text-white/90 tracking-widest uppercase mb-1">
              PAYPAL FUERA DE ARGENTINA
            </p>
            <p className="font-sans text-base md:text-lg font-bold text-white tracking-wide">
              {priceUSD}
            </p>
          </div>
        </div>
        
        {isExternal ? (
          <a href={link} className={buttonClassName} target="_blank" rel="noreferrer" aria-label={`Ver más sobre ${title}`}>Ver curso</a>
        ) : (
          <Link to={link} className={buttonClassName} aria-label={`Ver más sobre ${title}`}>Ver curso</Link>
        )}
      </div>
    </motion.div>
  );
}

export default CourseCard;
